import {axiosInstance} from "@/plugins/axios";
import {AgreementFilter} from "@/modules/agreement/types";

export async function getAgreements(payload: AgreementFilter) {

  let url = `agreements?`;

  if (payload && payload.limit) {
    url += `&limit=${payload.limit}&offset=${payload.offset}`;
  }

  if (payload && payload.id_agreement_group) {
    url += `&id_agreement_group=${payload.id_agreement_group}`;
  }

  if (payload && payload.search){
    url += `&search=${payload.search}`;
  }

  const response = await axiosInstance.get(url);

  return response.data;
}

export async function getAgreement(id: string) {
  const response = await axiosInstance.get(`agreements/${id}`);
  return response.data;
}

export async function getAgreementGroups(){
  const response = await axiosInstance.get(`agreement_groups`);
  return response.data;
}

export async function getAgreementGroup(id: string) {
  const response = await axiosInstance.get(`agreement_groups/${id}`);
  return response.data;
}
